import { useState, useEffect } from "react"
import styles from "./GroupChat.module.css"
import { Card, List, ListItem, TextField } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import { useApiService } from "../hooks/Api/useApiService"
import SendIcon from "@mui/icons-material/Send"
import Icn from "../UI/SharieIcn/SharieIcn"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import useError from "../hooks/Error/useError"

const GroupChat = (props) => {
  const [messages, setMessages] = useState([])
  const [should_fetch, setShouldFetch] = useState(false)
  const [inputValue, setInputValue] = useState("")
  const { postData } = useApiService()
  const t = useTranslationSharie()
  const { Error: AlertError, error, success } = useError()

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  const clearInput = () => {
    setInputValue("")
  }

  useEffect(() => {
    postData("sharie/getgroupmessages", {
      name: props.group.name,
      user_name: props.group.user_name,
    })
      .then((data) => {
        setMessages(data.messages)
      })
      .catch((error) => {
        error(error.message)
      })
  }, [props.group, should_fetch])

  const sendMessage = async (e) => {
    if ((e.ctrlKey && e.key === "Enter") || e === "send_icon") {
      postData("groups/addgroupmessage", {
        from: localStorage.getItem("user"),
        message: inputValue,
        group_name: props.group.name,
        user_name: props.group.user_name,
      })
        .then((data) => {
          setMessages(data.messages)
          clearInput()
          setShouldFetch(!should_fetch)
        })
        .catch((error) => {
          error(error.message)
        })
    }
  }

  const checkChatColors = (message) => {
    if (message.from === localStorage.getItem("user")) return "green"
    else return "black"
  }
  return (
    <T>
      <div className={styles.chatcontainer}>
        <Card className={styles.chat_card}>
          <List>
            {messages?.map((el, index) => {
              return (
                <ListItem key={index}>
                  <div
                    key={index}
                    className={
                      localStorage.getItem("user") === el.from
                        ? styles.message_div_user
                        : styles.message_div
                    }
                  >
                    {el.message}
                  </div>

                  {el.seen ? (
                    <>
                      <CheckIcon className={styles.icon}></CheckIcon>
                      <CheckIcon className={styles.icon}></CheckIcon>
                    </>
                  ) : (
                    <></>
                  )}
                </ListItem>
              )
            })}
          </List>
        </Card>
        <TextField
          multiline={true}
          style={{ backgroundColor: "background.paper" }}
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            sendMessage(e)
          }}
          label={t("Type your message...")}
        ></TextField>
        <Icn
          tooltip={"Send"}
          color={"inherit"}
          onClick={() => {
            sendMessage("send_icon")
          }}
          icon={<SendIcon />}
        />
        <AlertError />
      </div>
    </T>
  )
}

export default GroupChat
